import { SwitzerlandCantonsMap } from '@/maps/components/SwitzerlandCantonsMap'
import { FederalBallotSummary } from '@/domain/FederalBallotSummary'
import { OverrideableBallotState } from '@/domain/overrideable-ballot-state'
import { BREAKPOINTS } from '@ta-interaktiv/react-components'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { css } from 'styled-components/macro'
import { useEnv } from '@/lib/env'

const Root = 'a'

interface Props extends React.ComponentPropsWithoutRef<typeof Root> {
  popularVoteId: string
  federalBallotId: string

  state: OverrideableBallotState
  summary: FederalBallotSummary
}

function TileBottom(props: Props) {
  const { history } = useEnv()
  const { popularVoteId, federalBallotId, state, summary, ...rest } = props

  return (
    <Root
      css={styles.root as any}
      onClick={() => {
        history.push(`/${popularVoteId}/${federalBallotId}`)
        window.scrollTo({ top: 0 })
      }}
      {...rest}
    >
      <div css={styles.map as any}>
        <SwitzerlandCantonsMap
          date={new Date(Date.parse(popularVoteId))}
          width={100}
          state={state.ballotState}
          cantons={summary.cantons}
          includeLakes={false}
        />
      </div>
      <div css={styles.button as any}>
        <FormattedMessage
          id="components.PopularVoteContainer.Tile.resultat-nach-kanton"
          defaultMessage="Resultat nach Kanton"
        />
      </div>
    </Root>
  )
}

const styles = {
  root: css`
    background-color: var(--tile-background);
    min-height: 100px;
    padding: 0 10px;
    display: grid;
    grid-template-columns: 100px 1fr;
    grid-gap: 10px;
    align-items: center;
    cursor: pointer;
    text-decoration: none;

    @media only screen and (min-width: ${BREAKPOINTS.tablet}px) {
      grid-gap: 20px;
      padding: 0 20px;
    }
  `,

  map: css`
    padding: 3px 0;
    width: 100px;
  `,

  button: css`
    width: 100%;
    min-height: 40px;
    background: var(--button-background);
    &:hover {
      opacity: 0.7;
    }
    font-family: var(--font-sans-serif);
    font-weight: 700;
    font-size: 14px;
    line-height: 1.3;

    color: var(--site-background);

    display: grid;
    place-items: center;

    padding: 8px 20px;
    white-space: wrap;
    text-align: center;
  `,
}

export default TileBottom
